<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Unidades de Medida</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            v-model="searchTerm"
                            :placeholder="
                                this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar por Código o Nombre...'
                            "
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <argon-button
                        class="mt-0"
                        color="success"
                        fullWidth
                        size="xs"
                        @click="toCreate"
                    >
                        Agregar Nuevo
                    </argon-button>
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Código
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Nombre
                            </th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoadingCiaConfig">
                            <td colspan="5" class="text-center py-4 text-muted">Cargando configuración...</td>
                        </tr>
                        <tr v-else-if="filteredUnits.length === 0">
                            <td colspan="5" class="text-center py-4">
                                {{ searchTerm ? 'No hay coincidencias con la búsqueda.' : 'No se encontraron unidades.' }}
                            </td>
                        </tr>
                        <tr
                            v-for="(unit, index) in filteredUnits"
                            :key="index"
                        >
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm ps-2">{{ unit.code }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex flex-column justify-content-center">
                                    <p class="mb-0 text-sm">{{ unit.name }}</p>
                                </div>
                            </td>
                            <td class="align-middle">
                                <a
                                    @click="toEdit(unit.id)"
                                    class="btn bg-success mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Editar unidad"
                                ><i class="fa fa-pen text-white text-sm opacity-10"></i></a>

                                <a
                                    @click="deleteUnit(unit.id, unit.name)"
                                    class="btn bg-danger mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Eliminar unidad"
                                ><i class="fa fa-trash text-white text-sm opacity-10"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { useCompanyConfig } from '@/composables/useCompanyConfig';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    name: "UnitsTable",
    components: { ArgonButton },
    // 🛑 Nota: Ahora recibimos la lista de unidades por prop, como clients en tu ejemplo
    props: {
        units: {
            type: Array,
            default: () => []
        },
    },
    data(){
        return({
            searchTerm: null,
            // Las unidades se toman de la prop 'units'
            currency: 'USD',
            symbol: '$'
        })
    },
    setup(){
        const { companyConfig, isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        // Cargar la configuración de la compañía
        fetchCompanyConfig();
        return { companyConfig ,isLoadingCiaConfig};
    },
    computed:{
        filteredUnits(){
            // Retorna la prop 'units' si no hay término de búsqueda
            if(!this.searchTerm){
                return this.units;
            } else {
                // Filtra por 'code' o 'name'
                const term = this.searchTerm.toString().toLowerCase();
                return this.units.filter(item => {
                    const codeMatch = item.code.toString().toLowerCase().includes(term);
                    const nameMatch = item.name.toString().toLowerCase().includes(term);
                    return codeMatch || nameMatch;
                });
            }
        }
    },
    watch:{
        // CRÍTICO: Actualizar moneda y símbolo cuando la configuración cargue
        companyConfig(newVal){
            if (newVal) {
                this.currency = newVal.currency_code || 'USD';
                this.symbol = newVal.currency_symbol || '$';
            }
        },
    },
    methods:{
        toCreate(){
            // Asume que tienes esta ruta configurada
            this.$router.push('/settings/units/create');
        },
        toEdit(unitId) {
            this.$router.push(`/settings/units/view/${unitId}`);
        },
        deleteUnit(unitId, unitName){
            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': '*/*',
                    'Authorization': `Bearer ${token}`
                }
            };

            Swal.fire({
                title: `¿Eliminar unidad ${unitName}?`,
                text: '¡Esta acción no se puede deshacer!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(this.$store.state.apiURL + 'units/'+unitId, config)
                    .then(() => {
                        Swal.fire({
                            title: 'Unidad eliminada',
                            text: 'La unidad fue eliminada correctamente.',
                            icon: 'success',
                            confirmButtonColor: '#0b9257'
                        }).then(() => {
                            // 🛑 Emitir evento para que el componente padre recargue la lista
                            this.$emit('unit-deleted');
                        });
                    })
                    .catch((error) => {
                        console.error('Error al eliminar unidad:', error.response || error);
                        Swal.fire({
                            title: 'Error',
                            text: 'No se pudo eliminar la unidad. Podría estar en uso.',
                            icon: 'error',
                            confirmButtonColor: '#d33'
                        });
                    });
                }
            })
        },
    },
};
</script>